import * as Function from "../Function";
import * as Error from "../Error";
import * as ErrorCode from "../ErrorCode";
import { option } from "fp-ts/lib";

export const string: Function.TValidationFunction = (value: unknown): option.Option<Error.TValidationError> =>
    typeof value === "undefined" || typeof value === "string"
        ? option.none
        : option.some([[ErrorCode.validationErrorCodeConstants.STRING_VALIDATION]]);
